/* =====================================================================
   Cappafe Assistant — vehicle-fit product finder chat (uk.cappafe.com)
   Based on sparkoto "Mr. Spark". Local engine first (free, instant),
   DeepSeek via Cloudflare Worker only as fallback (key never in browser).
   Data: /collections/all?view=cappafe-assistant  (templates/collection.cappafe-assistant.liquid)
   Markup + config: snippets/cappafe-assistant.liquid
   ===================================================================== */
(function () {
  var root = document.getElementById("cai");
  if (!root || root.getAttribute("data-ready")) return;
  root.setAttribute("data-ready", "1");

  var D = root.dataset || {};
  var CFG = {
    name: "Cappafe Assistant",
    phone: D.phone || "447493312748",
    email: D.email || "support@cappafe.com",
    root: D.root || "/",
    worker: D.worker || "",
    index: D.index || "/collections/all?view=cappafe-assistant",
    currency: D.currency || "GBP"
  };
  function url(path) { return (CFG.root.replace(/\/$/, "") + "/" + String(path).replace(/^\//, "")); }
  var CONTACT_URL = url("pages/contact");
  var CACHE_KEY = "cai_idx_v1", CACHE_TTL = 30 * 60 * 1000;

  /* ------------------------------------------------------------------
     STORE FACTS used by FAQ answers — keep in sync with site policies
     ------------------------------------------------------------------ */
  var FACTS = {
    freeOver: "£99",                  // free UK delivery threshold (England & Wales) — confirmed by Eren 2026-09-14
    ewRate: "£5",                     // England & Wales below threshold
    deliveryTime: "1–3 working days", // confirmed by Eren 2026-09-14
    returnDays: "14",                 // confirmed by Eren 2026-09-14 (matches refund policy)
    shippingPolicy: url("policies/shipping-policy"),
    refundPolicy: url("policies/refund-policy")
  };

  /* ---------------------------- helpers ---------------------------- */
  function norm(s) {
    s = String(s == null ? "" : s).toLowerCase();
    if (s.normalize) s = s.normalize("NFD").replace(/[̀-ͯ]/g, "");
    return s.replace(/&/g, " and ").replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
  }
  function sing(w) { return (w.length > 3 && /s$/.test(w) && !/(ss|us|is)$/.test(w)) ? w.slice(0, -1) : w; }
  function singAll(s) { return s.split(" ").map(sing).join(" "); }
  function has(hay, needle) { return needle && (" " + hay + " ").indexOf(" " + needle + " ") >= 0; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function slug(s) { return norm(s).replace(/ /g, "-"); }
  var fmt; try { fmt = new Intl.NumberFormat("en-GB", { style: "currency", currency: CFG.currency }); } catch (e) { fmt = null; }
  function money(cents) { var n = (parseInt(cents, 10) || 0) / 100; return fmt ? fmt.format(n) : ("£" + n.toFixed(2)); }
  function track(ev, data) {
    data = data || {};
    try { window.dataLayer = window.dataLayer || []; var o = { event: ev }; for (var k in data) o[k] = data[k]; window.dataLayer.push(o); } catch (e) {}
    try { if (window.gtag) window.gtag("event", ev, data); } catch (e) {}
  }

  /* --------------------------- vocabulary -------------------------- */
  var MAKE_ALIASES = {
    "vw": "volkswagen", "volkswagon": "volkswagen", "merc": "mercedes", "mercedes benz": "mercedes", "benz": "mercedes",
    "chevy": "chevrolet", "landrover": "land rover", "range rover": "land rover", "mitsu": "mitsubishi", "ssang yong": "ssangyong",
    "citreon": "citroen", "peugot": "peugeot", "hyundia": "hyundai", "vauxhal": "vauxhall", "alfa": "alfa romeo", "mini cooper": "mini", "opel": "vauxhall"
  };
  var MAKE_GROUPS = [["vauxhall", "opel"]]; // same vehicles under two badges in the UK
  var MAKE_COLLECTION = { "volkswagen": "vw" }; // make -> brand collection handle when it differs from the slug
  // model names that are also everyday English words: only count them when the make is mentioned too
  var AMBIG = { "up": 1, "one": 1, "go": 1, "note": 1, "life": 1, "move": 1, "city": 1, "sport": 1, "van": 1, "pro": 1, "plus": 1, "max": 1, "class": 1, "cross": 1, "wagon": 1, "estate": 1, "custom": 1, "series": 1, "tourer": 1, "space": 1, "star": 1, "jazz": 1, "rio": 1 };

  // part vocabulary → product types (catalog custom types) + collection handle for "browse all"
  var PARTS = [
    { id: "bonnet", label: "bonnet deflectors", types: ["Bonnet Deflectors"], col: "bonnet-deflectors-hood-bug-deflectors",
      terms: ["bonnet deflector", "bug guard", "bug deflector", "bug shield", "hood deflector", "stone guard", "stone deflector", "bonnet guard", "bonnet protector", "bonnet shield", "bonnet visor", "wind stone deflector", "bonnet wind deflector"] },
    { id: "visor", label: "sun visors", types: ["Sun Visors"], col: "external-sunvisors-truck-roof-visors",
      terms: ["sun visor", "sunvisor", "windscreen visor", "windshield visor", "peak visor", "roof visor", "front visor", "sun shield", "windscreen shield", "visor"] },
    { id: "wind", label: "wind deflectors", types: ["Wind Deflectors"], col: "window-wind-deflectors",
      terms: ["wind deflector", "window deflector", "rain guard", "rain deflector", "side window deflector", "window visor", "air deflector", "wind rain deflector"] },
    { id: "roofbar", label: "roof bars", types: ["Cross Bar"], col: "cross-bars",
      terms: ["cross bar", "crossbar", "roof bar", "roof rack", "roof rail bar", "load bar", "roofbar", "roof rail"] },
    { id: "flare", label: "fender flares", types: ["Fender Flares", "Boot Lid Fender Flares"], col: "fender-flares",
      terms: ["fender flare", "wheel arch trim", "wheel arch extension", "arch trim", "arch flare", "arch extension", "fender trim", "wheel arch moulding", "arch moulding"] },
    { id: "rearsill", label: "rear bumper sill protectors", types: ["Rear Bumper Sill", "Boot Sill Protector"], col: "rear-bumper-boot-sill-protectors",
      terms: ["rear bumper sill", "bumper sill", "rear bumper protector", "bumper protector", "bumper guard", "boot sill", "loading sill", "rear sill protector", "boot protector", "tailgate sill", "rear bumper protection", "boot sill protector"] },
    { id: "doorsill", label: "door sill protectors", types: ["Door Sill Protector"], col: "door-sill-protectors-scuff-kick-plates",
      terms: ["door sill", "scuff plate", "kick plate", "sill plate", "door step plate", "door sill protector", "threshold plate"] },
    { id: "lip", label: "front bumper lips", types: ["Front Bumper Lip"], col: "bumper-lips",
      terms: ["bumper lip", "front lip", "lip spoiler", "splitter", "chin spoiler", "front spoiler", "front splitter", "lip"] },
    { id: "spoiler", label: "spoilers", types: ["Spoiler"], col: "rear-window-roof-spoilers",
      terms: ["spoiler", "roof spoiler", "rear spoiler", "boot spoiler", "rear wing", "tailgate spoiler", "wing"] },
    { id: "skirt", label: "side skirts", types: ["Side Skirt"], col: "side-skirts-body-kit-extensions",
      terms: ["side skirt", "sill extension", "side sill", "skirt"] },
    { id: "steps", label: "side steps", types: ["Side Steps"], col: "side-steps",
      terms: ["side step", "running board", "step bar", "nerf bar"] },
    { id: "mudflap", label: "mud flaps", types: ["Mud Flaps"], col: "front-rear-mud-flaps",
      terms: ["mud flap", "mudflap", "splash guard", "mud guard", "mudguard"] },
    { id: "scoop", label: "bonnet scoops", types: ["Scoop"], col: "hood-scoops",
      terms: ["bonnet scoop", "hood scoop", "air scoop", "scoop"] },
    { id: "diffuser", label: "bumper diffusers", types: ["Bumper Diffuser"], col: "bumper-diffusers",
      terms: ["diffuser", "rear diffuser", "bumper diffuser"] },
    { id: "cladding", label: "cladding & body kits", types: ["Door Cladding", "Body Cladding Kits"], col: "",
      terms: ["door cladding", "body cladding", "side moulding", "door moulding", "body kit", "cladding", "door protector"] },
    { id: "tailgate", label: "tailgate trims", types: ["Tailgate"], col: "",
      terms: ["tailgate trim", "tailgate cover", "boot lid trim", "tailgate protector", "tailgate"] },
    { id: "dragon", label: "Dragon Pack trim sets", types: ["Dragon Pack"], col: "dragon-pack-car-trim-sets",
      terms: ["dragon pack", "dragon"] },
    { id: "mirror", label: "mirror covers", types: ["Mirror Cover"], col: "",
      terms: ["mirror cover", "mirror cap", "wing mirror cover"] },
    { id: "bedrail", label: "bed rail protectors", types: ["Bed Rail Protector"], col: "pickup-bed-rail-protectors",
      terms: ["bed rail", "rail cap", "bed rail protector", "truck bed rail"] },
    { id: "archcover", label: "wheel arch covers", types: ["Wheel Arch Cover"], col: "rear-wheel-arch-covers-protectors",
      terms: ["wheel arch cover", "arch cover", "arch guard"] },
    { id: "quarter", label: "quarter window trims", types: ["Quarter Window"], col: "quarter-window-trims",
      terms: ["quarter window", "quarter glass"] },
    { id: "wtrim", label: "window trims", types: ["Window Trim"], col: "",
      terms: ["window trim", "chrome window trim", "window chrome"] },
    { id: "pedal", label: "pedal pads", types: ["Pedal Pads"], col: "", terms: ["pedal pad", "pedal cover", "pedal"] },
    { id: "interior", label: "interior trims", types: ["Interior Trim"], col: "interior-trim-kits", terms: ["interior trim", "dashboard trim", "dash trim"] },
    { id: "handle", label: "door handle covers", types: ["Door Handle"], col: "", terms: ["door handle", "handle cover"] },
    { id: "indicator", label: "indicators", types: ["Indicators"], col: "", terms: ["indicator", "side repeater", "repeater"] },
    { id: "grille", label: "grilles", types: ["Grilles"], col: "", terms: ["grille", "grill"] },
    { id: "set", label: "combo sets", types: ["Sets"], col: "", terms: ["combo", "bundle", "set"] }
  ];
  PARTS.forEach(function (p) {
    p.nterms = p.terms.map(function (t) { return singAll(norm(t)); }).sort(function (a, b) { return b.length - a.length; });
    p.typeSet = {}; p.types.forEach(function (t) { p.typeSet[t] = 1; });
  });

  /* ------------------------------ data ------------------------------ */
  var DATA = [], MAKES = {}, MODELS = {}, loaded = false, loading = false, queue = [];

  function titleRanges(title) {
    var t = String(title || ""), out = [], m, re = /(\d{4})\s*[-–]\s*(\d{4})/g;
    while ((m = re.exec(t))) out.push([+m[1], +m[2]]);
    if (!out.length) { var o = t.match(/(\d{4})\s*(?:onwards|\+)/i); if (o) out.push([+o[1], 9999]); }
    return out;
  }
  function parseRanges(arr, title) {
    // the product title is the most reliable fitment source (some year metafields are mis-set)
    var fromTitle = titleRanges(title);
    if (fromTitle.length) return fromTitle;
    var out = [];
    (arr || []).forEach(function (s) {
      s = String(s);
      var r = s.match(/(\d{4})\s*[-–]\s*(\d{4})/); if (r) { out.push([+r[1], +r[2]]); return; }
      var o = s.match(/(\d{4})\s*(?:onwards|\+|on\b)/i); if (o) { out.push([+o[1], 9999]); return; }
      var y = s.match(/(\d{4})/); if (y) out.push([+y[1], +y[1]]);
    });
    return out;
  }
  function modelTokens(model) { return norm(model).split(" ").filter(Boolean); }
  // a trailing generation marker ("Vivaro A", "Vivaro B", "Sprinter II") is optional when matching
  function requiredTokens(toks) {
    if (toks.length > 1 && /^([a-z]|[1-9]|i{1,3}|iv|v|vi)$/.test(toks[toks.length - 1]) && !/^\d+$/.test(toks[0])) return toks.slice(0, -1);
    return toks;
  }
  function build(list) {
    MAKES = {}; MODELS = {};
    return list.map(function (x) {
      var mk = (x.mk || []).map(norm).filter(Boolean);
      var p = {
        h: x.h, t: x.t || "", pt: x.pt || "", mk: mk, mkLabel: (x.mk || [])[0] || "", md: x.md || "", vt: x.vt || "",
        p: x.p || 0, c: x.c || 0, v: x.v || 0, a: !!x.a, i: x.i || "", ys: x.y || [],
        yr: parseRanges(x.y, x.t), nt: singAll(norm(x.t))
      };
      p.mtoks = p.md ? modelTokens(p.md) : [];
      p.mcompact = norm(p.md).replace(/ /g, "");
      mk.forEach(function (m) { MAKES[m] = MAKES[m] || { label: x.mk[mk.indexOf(m)] || m, n: 0 }; MAKES[m].n++; });
      if (p.md && mk[0]) {
        var key = mk[0] + "|" + norm(p.md);
        if (!MODELS[key]) MODELS[key] = { key: key, make: mk[0], makeLabel: p.mkLabel, model: p.md, toks: p.mtoks, req: requiredTokens(p.mtoks), compact: p.mcompact, n: 0 };
        MODELS[key].n++; p.key = key;
      }
      return p;
    });
  }
  function fetchPage(n) {
    var u = CFG.index + (CFG.index.indexOf("?") >= 0 ? "&" : "?") + "page=" + n;
    return fetch(u, { credentials: "same-origin" }).then(function (r) { return r.json(); });
  }
  function load(cb) {
    if (loaded) return cb && cb();
    if (cb) queue.push(cb);
    if (loading) return; loading = true;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
      if (c && c.t && (Date.now() - c.t) < CACHE_TTL && c.d && c.d.length) { DATA = build(c.d); return finish(); }
    } catch (e) {}
    fetchPage(1).then(function (j) {
      var all = j.products || [], pages = Math.min(j.pages || 1, 20), ps = [];
      for (var i = 2; i <= pages; i++) ps.push(fetchPage(i));
      return Promise.all(ps).then(function (rs) { rs.forEach(function (r) { all = all.concat(r.products || []); }); return all; });
    }).then(function (all) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: all })); } catch (e) {}
      DATA = build(all); finish();
    }).catch(function () { finish(); });
  }
  function finish() { loaded = true; loading = false; var q = queue.slice(); queue = []; q.forEach(function (f) { try { f(); } catch (e) {} }); }

  /* ----------------------------- engine ----------------------------- */
  function sameMake(a, b) {
    if (a === b) return true;
    return MAKE_GROUPS.some(function (g) { return g.indexOf(a) >= 0 && g.indexOf(b) >= 0; });
  }
  function detectMakes(nq) {
    var found = [];
    Object.keys(MAKE_ALIASES).forEach(function (a) { if (has(nq, a)) found.push(MAKE_ALIASES[a]); });
    Object.keys(MAKES).forEach(function (m) { if (has(nq, m)) found.push(m); });
    return found.filter(function (m, i) { return found.indexOf(m) === i; });
  }
  // global longest-term-first matching so "wing mirror cover" is a mirror cover, not a spoiler ("wing")
  var PART_TERMS = [];
  PARTS.forEach(function (p) { p.nterms.forEach(function (t) { PART_TERMS.push({ t: t, p: p }); }); });
  PART_TERMS.sort(function (a, b) { return b.t.length - a.t.length; });
  function detectParts(sq) {
    var hits = [], used = " " + sq + " ";
    PART_TERMS.forEach(function (x) {
      if (used.indexOf(" " + x.t + " ") >= 0) {
        if (hits.indexOf(x.p) < 0) hits.push(x.p);
        used = used.split(" " + x.t + " ").join(" # ");
      }
    });
    // "set"/"combo" alone is not a part filter when another part is present
    if (hits.length > 1) hits = hits.filter(function (p) { return p.id !== "set"; });
    return hits;
  }
  function queryCompacts(nq) {
    var qt = nq.split(" "), set = {};
    qt.forEach(function (t, i) { set[t] = 1; if (qt[i + 1]) set[t + qt[i + 1]] = 1; if (qt[i + 2]) set[t + qt[i + 1] + qt[i + 2]] = 1; });
    return set;
  }
  function modelMatches(m, nq, qc, makes) {
    var makeSaid = makes.some(function (k) { return sameMake(k, m.make); });
    var numericOnly = m.req.every(function (t) { return /^\d+$/.test(t); });
    var ambiguous = m.req.every(function (t) { return AMBIG[t] || t.length < 2; });
    if ((numericOnly || ambiguous) && !makeSaid) return false; // "2008", "500", "Up" need the make
    if (m.req.every(function (t) { return has(nq, t); })) return true;
    return m.compact.length >= 3 && /[a-z]/.test(m.compact) && !!qc[m.compact]; // "l200" = "L 200", "dmax" = "D-Max", "xclass" = "X-Class"
  }
  function detectYear(rawLower, nq, makes) {
    var cands = (nq.match(/\b(19[5-9]\d|20[0-3]\d)\b/g) || []).map(Number);
    if (cands.length) {
      // drop numbers that are really model names for a mentioned make (Peugeot 2008 / 3008)
      var modelNums = {};
      Object.keys(MODELS).forEach(function (k) { var m = MODELS[k]; if (makes.some(function (mk) { return sameMake(mk, m.make); })) m.toks.forEach(function (t) { if (/^\d{4}$/.test(t)) modelNums[t] = 1; }); });
      var real = cands.filter(function (y) { return !modelNums[String(y)]; });
      if (real.length) return real[real.length - 1];
      if (cands.length > 1) return cands[cands.length - 1];
      return 0;
    }
    // UK registration year: "18 plate", "68 reg", full plate "YE18 ABC", or bare "YE18" (never a model token like XC90/XC60)
    var maxYear = new Date().getFullYear() + 1;
    var modelToks = {};
    Object.keys(MODELS).forEach(function (k) { MODELS[k].toks.forEach(function (t) { modelToks[t] = 1; }); modelToks[MODELS[k].compact] = 1; });
    var p = nq.match(/\b(\d{2})\s*(?:plate|reg|registration)\b/) || rawLower.match(/\b[a-z]{2}\s?(\d{2})\s?[a-z]{3}\b/);
    if (!p) {
      var bare = rawLower.match(/\b([a-z]{2})(\d{2})\b/);
      if (bare && !modelToks[bare[1] + bare[2]]) p = [bare[0], bare[2]];
    }
    if (p) {
      var n = +p[1], yr = 0;
      if (n >= 2 && n <= 50) yr = 2000 + n; else if (n >= 51 && n <= 99) yr = 2000 + n - 50;
      if (yr && yr <= maxYear) return yr;
    }
    return 0;
  }
  function inYears(p, y) { if (!y) return true; if (!p.yr.length) return true; return p.yr.some(function (r) { return y >= r[0] && y <= r[1]; }); }
  function yearDistance(p, y) { if (!y || !p.yr.length) return 0; var d = 1e9; p.yr.forEach(function (r) { d = Math.min(d, y < r[0] ? r[0] - y : (y > r[1] ? y - r[1] : 0)); }); return d; }
  function partHit(p, parts) {
    var best = 0;
    parts.forEach(function (pt) {
      if (pt.typeSet[p.pt]) best = Math.max(best, 2);
      else if (p.pt === "Sets" && pt.id !== "set" && pt.nterms.some(function (t) { return has(p.nt, t); })) best = Math.max(best, 1);
    });
    return best;
  }

  function analyse(raw) {
    var rawLower = String(raw || "").toLowerCase();
    var nq = norm(raw);
    var sq = singAll(nq);
    var makes = detectMakes(nq);
    var models = [], qc = queryCompacts(nq);
    Object.keys(MODELS).forEach(function (k) { var m = MODELS[k]; if (modelMatches(m, nq, qc, makes)) models.push(m); });
    if (makes.length) models = models.filter(function (m) { return makes.some(function (mk) { return sameMake(mk, m.make); }); });
    function fullyTyped(m) { return m.toks.every(function (t) { return has(nq, t); }); }
    // keep the most specific model the customer actually typed (Transit Custom beats Transit; Vivaro B beats Vivaro)
    models = models.filter(function (m) {
      return !models.some(function (o) { return o !== m && sameMake(o.make, m.make) && o.toks.length > m.toks.length && fullyTyped(o) && m.toks.every(function (t) { return o.toks.indexOf(t) >= 0; }); });
    });
    // a model made only of the words that identified the make ("Range Rover") loses to a more specific one ("Evoque")
    var makeWords = {};
    Object.keys(MAKE_ALIASES).concat(Object.keys(MAKES)).forEach(function (a) { if (has(nq, a)) a.split(" ").forEach(function (w) { makeWords[w] = 1; }); });
    var specific = models.filter(function (m) { return m.toks.some(function (t) { return !makeWords[t]; }); });
    if (specific.length) models = specific;
    var parts = detectParts(sq), year = detectYear(rawLower, nq, makes);
    // words we could not explain (probably a model we don't stock, e.g. "vw up")
    var known = {};
    function know(w) { known[w] = 1; known[sing(w)] = 1; }
    Object.keys(MAKE_ALIASES).concat(Object.keys(MAKES)).forEach(function (k) { if (has(nq, k)) k.split(" ").forEach(know); });
    parts.forEach(function (p) { p.nterms.forEach(function (t) { t.split(" ").forEach(function (w) { known[w] = 1; }); }); });
    models.forEach(function (m) { m.toks.forEach(know); });
    var leftover = sq.split(" ").filter(function (w) {
      return w && !known[w] && !known[sing(w)] && !STOPWORDS[w] && !/^(19|20)\d{2}$/.test(w) && !/^\d{1,2}$/.test(w) && !/^[a-z]{2}\d{2}$/.test(w) && w.length > 1;
    });
    return { raw: raw, nq: nq, sq: sq, makes: makes, models: models, parts: parts, year: year, leftover: leftover };
  }
  var STOPWORDS = {};
  ("a an the for my our your i im we need needs want looking look find show me please pls any have has got do does you your can could "
    + "with on to of in is are it its this that these those and or car van cars vans vehicle vehicles part parts accessory accessories "
    + "fit fits fitting fitted suit suits suitable compatible plate reg registration year years model models new old front rear pair set "
    + "black chrome matt gloss price cost how much buy order uk thanks thank hi hello mk gen generation shape facelift truck pickup suv 4x4 estate hatchback saloon").split(" ").forEach(function (w) { STOPWORDS[w] = 1; });
  function vehicleLabel(A, items) {
    var m = A.models[0];
    var base = m ? (m.makeLabel + " " + m.model) : (A.makes[0] && MAKES[A.makes[0]] ? MAKES[A.makes[0]].label : "");
    if (!base && items && items[0]) base = (items[0].mkLabel + " " + items[0].md).trim();
    return base + (A.year ? " " + A.year : "");
  }
  function search(raw) {
    var A = analyse(raw);
    var hasVehicle = A.models.length || A.makes.length;
    if (!hasVehicle) return { items: [], A: A, reason: A.parts.length ? "needvehicle" : "nothing" };
    if (!A.models.length && !A.parts.length) return { items: [], A: A, reason: "needmodel" };

    var modelKeys = {}; A.models.forEach(function (m) { modelKeys[m.key] = 1; });
    // also accept products whose model field is a shortened form of the chosen model when the title proves it
    // (e.g. model "Custom" on a "Ford Transit Custom" listing)
    function fitsModel(p) {
      if (modelKeys[p.key]) return true;
      if (!p.key) return false;
      var pm = MODELS[p.key];
      return A.models.some(function (m) {
        return sameMake(pm.make, m.make) && pm.toks.length < m.toks.length && pm.toks.every(function (t) { return m.toks.indexOf(t) >= 0; }) && m.toks.every(function (t) { return has(p.nt, sing(t)) || has(p.nt, t); });
      });
    }
    var pool = DATA.filter(function (p) {
      if (A.models.length) { if (!fitsModel(p)) return false; }
      else if (!p.mk.some(function (m) { return A.makes.some(function (k) { return sameMake(k, m); }); })) return false;
      if (A.parts.length && !partHit(p, A.parts)) return false;
      return true;
    });

    function score(p) {
      var s = 1, ph = A.parts.length ? partHit(p, A.parts) : 0;
      if (A.models.length) s += 8;
      if (ph === 2) s += 6; else if (ph === 1) s += 3;
      if (A.year && inYears(p, A.year) && p.yr.length) s += 4;
      if (p.a) s += 4; // something the customer can actually buy comes first
      return s;
    }
    function rank(list) { return list.map(function (p) { return { p: p, s: score(p) }; }).sort(function (a, b) { return (b.s - a.s) || (a.p.p - b.p.p); }).map(function (x) { return x.p; }); }

    var strict = A.year ? pool.filter(function (p) { return inYears(p, A.year); }) : pool;
    if (!A.models.length && A.leftover.length) {
      // make + part but an unrecognised model word: say so instead of silently showing every model of that make
      return { items: rank(strict.length ? strict : pool), A: A, reason: "unknownmodel" };
    }
    if (strict.length) return { items: rank(strict), A: A, reason: "ok" };
    if (A.year && pool.length) {
      var near = pool.slice().sort(function (a, b) { return yearDistance(a, A.year) - yearDistance(b, A.year); });
      return { items: rank(near.slice(0, 8)), A: A, reason: "nearest" };
    }
    if (A.models.length && A.parts.length) {
      var anyYear = DATA.filter(function (p) { return fitsModel(p); });
      var inYear = anyYear.filter(function (p) { return inYears(p, A.year); });
      var other = inYear.length ? inYear : anyYear;
      if (other.length) return { items: [], A: A, reason: "nopart", other: other };
    }
    return { items: [], A: A, reason: "none" };
  }

  /* ------------------------------ FAQ ------------------------------ */
  function faqAnswers() {
    return {
      ship: "🚚 We ship from our UK warehouse. <b>Free UK delivery on orders over " + FACTS.freeOver + "</b> (England &amp; Wales, " + FACTS.ewRate + " below that). Scotland and Northern Ireland have a flat delivery charge shown at checkout. Estimated delivery: <b>" + FACTS.deliveryTime + "</b>. <a href=\"" + FACTS.shippingPolicy + "\">Shipping policy</a>",
      intl: "🌍 We also ship to the EU and the US. Delivery costs are calculated at checkout, and international orders may be subject to customs duties paid by the recipient. <a href=\"" + FACTS.shippingPolicy + "\">Shipping policy</a>",
      returns: "↩️ <b>" + FACTS.returnDays + "-day returns.</b> Items must be unused and in their original packaging. To start a return, email <a href=\"mailto:" + CFG.email + "\">" + CFG.email + "</a> with your order number. <a href=\"" + FACTS.refundPolicy + "\">Refund &amp; returns policy</a>",
      track: "📦 Tracking details are emailed to you as soon as your order is dispatched. For an update on your order, message us with your <b>order number</b> and we'll check it for you:",
      fit: "🔧 Our parts are <b>made for specific vehicles</b> with a direct-fit design, and each one comes with a <b>fixing kit and installation instructions</b>. A few items (for example some sun visors) need light drilling — this is always stated under <i>In the Box</i> on the product page.",
      roofbars: "🧰 Our roof bars fit vehicles with <b>raised (open) roof rails</b>. Each listing is matched to a specific make, model, body type and year — please check that your roof rail type matches the listing before ordering. Tell me your vehicle and I'll find the right set.",
      quality: "✅ Our accessories are made from durable materials such as high-impact acrylic, ABS and anodised aluminium, precision-shaped for each vehicle. They're quality <b>aftermarket</b> parts (not OEM) — the car maker's name is used only to show fitment.",
      pay: "💳 Secure checkout with Visa, Mastercard, Maestro, American Express, PayPal, Apple Pay, Google Pay and Shop Pay.",
      discount: "🎁 Sign up to our newsletter and get <b>10% off your first order</b> — look for the sign-up offer on the site.",
      contact: "📞 Happy to help! You can reach our team here:"
    };
  }
  var FAQ = [
    { id: "track", k: ["where is my order", "where is my parcel", "track my order", "track order", "track parcel", "tracking number", "tracking", "order status", "my order", "not arrived", "hasnt arrived", "has not arrived", "dispatched yet"] },
    { id: "intl", k: ["international", "europe", "eu", "usa", "united states", "america", "abroad", "worldwide", "ireland", "germany", "france", "overseas", "outside uk"] },
    { id: "ship", k: ["delivery", "deliver", "shipping", "postage", "how long", "when will", "arrive", "dispatch", "courier", "scotland", "northern ireland", "highland", "free delivery", "next day"] },
    { id: "returns", k: ["return", "refund", "exchange", "send back", "cancel", "money back", "wrong item", "doesnt fit", "does not fit"] },
    { id: "roofbars", k: ["roof rail", "raised rail", "flush rail", "fit my roof", "roof bar fit"] },
    { id: "fit", k: ["fit it", "fitting", "install", "installation", "instruction", "drill", "drilling", "tape", "how to fit", "easy to fit", "clip"] },
    { id: "quality", k: ["warranty", "guarantee", "quality", "material", "oem", "genuine", "original", "durable", "made of", "acrylic"] },
    { id: "pay", k: ["payment", "pay", "paypal", "card", "apple pay", "google pay", "klarna", "instalment", "installment"] },
    { id: "discount", k: ["discount", "coupon", "promo code", "voucher", "offer", "sale", "code"] },
    { id: "contact", k: ["contact", "phone", "call", "email", "speak", "human", "person", "agent", "whatsapp", "customer service", "support", "help me"] }
  ];
  FAQ.forEach(function (f) { f.nk = f.k.map(norm); });
  function faqFind(q) {
    var n = norm(q);
    if (has(n, "northern ireland") || has(n, "scotland")) return "ship"; // UK regions, not international
    for (var i = 0; i < FAQ.length; i++) if (FAQ[i].nk.some(function (k) { return has(n, k); })) return FAQ[i].id;
    return null;
  }

  /* --------------------------- small talk --------------------------- */
  var SMALL = [
    { k: ["hi", "hello", "hey", "hiya", "good morning", "good afternoon", "good evening", "morning", "alright", "yo"],
      a: "Hi there! 👋 I'm the <b>Cappafe Assistant</b>. Tell me your vehicle's <b>make, model and year</b> — for example “Ford Transit Custom 2019 bonnet deflector” — and I'll show you the parts that fit. 🚗" },
    { k: ["how are you", "how r u", "hows it going", "how is it going", "you ok"],
      a: "I'm great, thanks for asking! 😄 Which vehicle are we shopping for today? Just type the <b>make, model and year</b>." },
    { k: ["thanks", "thank you", "cheers", "ta", "thx", "much appreciated", "brilliant", "great"],
      a: "You're welcome! 🙏 If you need anything else for your vehicle, I'm right here." },
    { k: ["bye", "goodbye", "see you", "see ya", "later", "that is all", "thats all"],
      a: "Thanks for stopping by! 👋 Safe driving — I'm here whenever you need me." },
    { k: ["who are you", "what are you", "your name", "are you a bot", "are you real", "are you human", "robot"],
      a: "I'm the <b>Cappafe Assistant</b> 🤖 — a virtual helper for Cappafe's vehicle-specific accessories. I can find <b>bonnet deflectors, wind deflectors, sun visors, roof bars, fender flares, bumper protectors</b> and more for your car or van. For anything I can't answer, our team is on WhatsApp." },
    { k: ["what can you do", "what do you do", "what do you sell", "what have you got", "how does this work", "help"],
      a: "I find accessories that <b>fit your exact vehicle</b> 🚐 Tell me the <b>make, model and year</b> (your reg plate year works too, e.g. “18 plate”) plus the part you need. I'll show price, stock and a quick add-to-basket button." }
  ];
  var SMALLTOK = []; SMALL.forEach(function (s) { s.nk = s.k.map(norm); s.nk.forEach(function (k) { SMALLTOK.push(k); }); });
  SMALLTOK.sort(function (a, b) { return b.length - a.length; });
  function small(q) {
    var n = norm(q);
    if (detectParts(singAll(n)).length) return null;
    var hit = null;
    for (var i = 0; i < SMALL.length; i++) if (SMALL[i].nk.some(function (k) { return has(n, k); })) { hit = SMALL[i]; break; }
    if (!hit) return null;
    var rest = " " + n + " ";
    SMALLTOK.forEach(function (t) { rest = rest.split(" " + t + " ").join(" "); });
    rest = rest.replace(/\b(there|mate|please|pls|you|so|much|very|again|guys|team|cappafe|assistant|i|am|ok|okay)\b/g, " ").replace(/\s+/g, " ").trim();
    return (rest ? rest.split(" ").length : 0) <= 1 ? hit.a : null;
  }

  /* --------------------------- vehicle memory --------------------------- */
  function saveVeh(label) { try { if (label) localStorage.setItem("cai_veh", label); } catch (e) {} }
  function lastVeh() { try { return localStorage.getItem("cai_veh") || ""; } catch (e) { return ""; } }

  /* ------------------------------- UI ------------------------------- */
  var card = root.querySelector(".cai-card"), fab = root.querySelector(".cai-fab"), closeBtn = root.querySelector(".cai-x"),
      body = root.querySelector(".cai-body"), input = root.querySelector(".cai-input"), sendBtn = root.querySelector(".cai-send"),
      started = false, toastEl = null;
  if (!card || !fab || !body || !input) return;

  function setOpen(o) {
    if (o) hideTip();
    card.classList.toggle("cai-open", o);
    card.setAttribute("aria-hidden", o ? "false" : "true");
    fab.setAttribute("aria-expanded", o ? "true" : "false");
    fab.classList.toggle("cai-on", o);
    if (o) {
      load();
      if (!started) { started = true; greet(); track("cai_open", {}); }
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 180);
    }
  }
  function scroll() { body.scrollTop = body.scrollHeight; }
  function botHTML(html) { var r = document.createElement("div"); r.className = "cai-row"; r.innerHTML = '<div class="cai-bubble cai-bot">' + html + "</div>"; body.appendChild(r); scroll(); return r; }
  function userText(t) { var r = document.createElement("div"); r.className = "cai-row cai-me"; r.innerHTML = '<div class="cai-bubble cai-user"></div>'; r.firstChild.textContent = t; body.appendChild(r); scroll(); }
  function typingDots() { return botHTML('<span class="cai-typing"><span></span><span></span><span></span></span>'); }
  function botType(html, done) {
    var r = botHTML(""), b = r.firstChild;
    var tokens = String(html).match(/<[^>]+>|&[a-z#0-9]+;|[\s\S]/g) || [];
    var i = 0, buf = "";
    if (tokens.length > 420) { b.innerHTML = html; scroll(); if (done) done(); return r; }
    b.classList.add("cai-caret");
    // time-based reveal (~70 chars/s) so throttled timers (background tabs) never stall the reply
    var t0 = Date.now(), finished = false, typer = {};
    function finish() {
      if (finished) return; finished = true;
      typers.splice(typers.indexOf(typer), 1);
      b.innerHTML = html; b.classList.remove("cai-caret"); scroll(); if (done) done();
    }
    typer.finish = finish; typers.push(typer);
    (function step() {
      if (finished) return;
      var target = Math.floor((Date.now() - t0) / 14) + 1;
      while (i < tokens.length && (i < target || /^[<&]/.test(tokens[i]))) buf += tokens[i++];
      if (i >= tokens.length) return finish();
      b.innerHTML = buf; scroll();
      setTimeout(step, 24);
    })();
    return r;
  }
  var typers = [];
  // a new question finishes any reply that is still typing, so answers never interleave
  function flushTyping() { typers.slice().forEach(function (t) { t.finish(); }); }
  function afterDots(ms, cb) { var d = typingDots(); setTimeout(function () { d.remove(); cb(); }, ms); }
  function toast(msg, href, link) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "cai-toast"; card.appendChild(toastEl); }
    toastEl.innerHTML = esc(msg) + (href ? ' <a href="' + esc(href) + '">' + esc(link || "Go") + "</a>" : "");
    toastEl.classList.add("cai-show"); clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("cai-show"); }, 4000);
  }

  var WA_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 13.9c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1.1c.2-.3.4-.2.6-.1l1.9.9c.3.1.4.2.5.3.1.2.1.8-.1 1.4z"/></svg>';
  var MAIL_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5-8-5V6l8 5 8-5z"/></svg>';
  var NOTE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm-1 7V3.5L18.5 9zM8 13h8v2H8zm0 4h5v2H8z"/></svg>';
  var REQS = [];
  function cap(s) { s = String(s || ""); return s.charAt(0).toUpperCase() + s.slice(1); }
  // what we already know about the vehicle/part, used to pre-fill the request form
  function reqCtx(A, q, p) {
    var m = A && A.models && A.models[0], mk = A && A.makes && A.makes[0];
    // the model the customer typed ("Transit Custom") beats a shortened product field ("Custom")
    if (p && !(m && p.mk.some(function (x) { return sameMake(x, m.make); }))) m = null;
    return {
      make: m ? m.makeLabel : (p ? p.mkLabel : (mk ? (MAKES[mk] ? MAKES[mk].label : cap(mk)) : "")),
      model: m ? m.model : (p ? p.md : (A && A.leftover && A.leftover.length ? cap(A.leftover.join(" ")) : "")),
      year: A && A.year ? String(A.year) : (p && p.ys && p.ys[0] ? String(p.ys[0]).slice(0, 9) : ""),
      part: p ? p.pt : (A && A.parts && A.parts.length ? cap(A.parts[0].label) : ""),
      product: p ? p.t : "", productUrl: p ? location.origin + url("products/" + p.h) : "", query: q || ""
    };
  }
  function reqBtn(ctx, cls) {
    REQS.push(ctx);
    return '<button type="button" class="' + (cls || "cai-hbtn cai-reqb") + '" data-req="' + (REQS.length - 1) + '">' + NOTE_SVG + "<span>Request this part</span></button>";
  }
  function handoff(q, ctx) {
    var text = "Hi Cappafe, I need help" + (q ? " with: " + q : ".");
    return '<div class="cai-hand">' + (ctx ? reqBtn(ctx) : "")
      + '<a class="cai-hbtn cai-wa" data-handoff="whatsapp" target="_blank" rel="noopener" href="https://wa.me/' + esc(CFG.phone) + "?text=" + encodeURIComponent(text) + '">' + WA_SVG + "<span>WhatsApp us</span></a>"
      + '<a class="cai-hbtn cai-mail" data-handoff="contact" href="' + esc(CONTACT_URL) + '">' + MAIL_SVG + "<span>Contact form</span></a>"
      + "</div>";
  }
  function wire(node) {
    Array.prototype.forEach.call(node.querySelectorAll(".cai-chip"), function (b) {
      b.addEventListener("click", function () {
        if (b.getAttribute("data-faq-menu")) { userText("FAQs"); showFAQ(); return; }
        input.value = b.getAttribute("data-q") || ""; go();
      });
    });
    Array.prototype.forEach.call(node.querySelectorAll("[data-handoff]"), function (a) {
      a.addEventListener("click", function () { track("cai_handoff", { channel: a.getAttribute("data-handoff") }); });
    });
    Array.prototype.forEach.call(node.querySelectorAll("[data-req]"), function (b) {
      b.addEventListener("click", function () { showRequestForm(REQS[+b.getAttribute("data-req")] || {}); track("cai_request_open", {}); });
    });
    Array.prototype.forEach.call(node.querySelectorAll(".cai-cart[data-vid]"), function (b) {
      b.addEventListener("click", function () { addToCart(+b.getAttribute("data-vid"), b.getAttribute("data-t"), b); });
    });
    Array.prototype.forEach.call(node.querySelectorAll("[data-click]"), function (a) {
      a.addEventListener("click", function () { track("cai_product_click", { handle: a.getAttribute("data-click") }); });
    });
  }
  function chip(label, q) { return '<button class="cai-chip" type="button" data-q="' + esc(q) + '">' + label + "</button>"; }

  function greet() {
    var chips = chip("🚐 Ford Transit bonnet deflector", "Ford Transit 2019 bonnet deflector")
      + chip("🚚 Delivery", "delivery")
      + '<button class="cai-chip" type="button" data-faq-menu="1">❓ FAQs</button>';
    wire(botHTML("Hi, I'm the <b>Cappafe Assistant</b> 👋<br>Let's find parts that fit your vehicle — just tell me the <b>make, model and year</b> (your plate year works too) and what you're looking for.<div class=\"cai-chips\">" + chips + "</div>"));
  }
  function showFAQ() {
    var chips = chip("🚚 Delivery", "delivery") + chip("↩️ Returns", "returns") + chip("🔧 Fitting", "how to fit")
      + chip("🧰 Roof bar fitment", "roof rail") + chip("💳 Payment", "payment") + chip("📦 Track my order", "track my order")
      + chip("🌍 International", "international delivery");
    wire(botHTML("Here are the most common questions 👇<div class=\"cai-chips\">" + chips + "</div>"));
  }

  function productCard(p) {
    var href = url("products/" + p.h);
    var thumb = p.i ? '<img class="cai-thumb" src="' + esc(p.i) + '" alt="" loading="lazy" width="52" height="52">' : '<span class="cai-thumb">🚗</span>';
    var meta = '<span class="cai-price">' + money(p.p) + "</span>";
    if (p.c && p.c > p.p) {
      meta += '<span class="cai-old">' + money(p.c) + "</span>";
      var d = Math.round((1 - p.p / p.c) * 100); if (d > 0) meta += '<span class="cai-badge cai-disc">-' + d + "%</span>";
    }
    meta += p.a ? '<span class="cai-badge cai-in">In stock</span>' : '<span class="cai-badge cai-outb">Sold out</span>';
    var act = (p.a && p.v) ? '<button class="cai-cart" type="button" data-vid="' + p.v + '" data-t="' + esc(p.t) + '">Add to basket</button>' : reqBtn(reqCtx(curA, curQ, p), "cai-cart cai-reqc");
    return '<div class="cai-pc"><a class="cai-pctop" href="' + esc(href) + '" data-click="' + esc(p.h) + '">' + thumb
      + '<span class="cai-info"><span class="cai-t">' + esc(p.t) + '</span><span class="cai-pm">' + meta + "</span></span></a>"
      + '<div class="cai-act">' + act + '<a class="cai-view" href="' + esc(href) + '" data-click="' + esc(p.h) + '">View</a></div></div>';
  }
  function moreLink(r) {
    var A = r.A, m = A.models[0];
    if (!m) return "";
    var href = url("collections/" + (MAKE_COLLECTION[m.make] || slug(m.makeLabel))) + "?filter.p.m.custom.model=" + encodeURIComponent(m.model);
    return '<a class="cai-more" href="' + esc(href) + '">See all ' + esc(m.makeLabel + " " + m.model) + " parts →</a>";
  }
  var curA = null, curQ = "";
  function showResults(q, r) {
    var A = r.A, items = r.items;
    curA = A; curQ = q;
    if (!items.length) return noResult(q, r);
    if (r.reason === "unknownmodel") {
      var mkl = MAKES[A.makes[0]] ? MAKES[A.makes[0]].label : A.makes[0];
      var pl = A.parts.map(function (p) { return p.label; }).join(" & ");
      var hu = "I couldn't match “<b>" + esc(A.leftover.join(" ")) + "</b>” to a " + esc(mkl) + " model we stock" + (pl ? " for " + esc(pl) : "") + " 🤔";
      var col = A.parts[0] && A.parts[0].col ? '<a class="cai-more" href="' + esc(url("collections/" + A.parts[0].col)) + '">Browse all ' + esc(A.parts[0].label) + " →</a>" : "";
      wire(botHTML(hu + "<br>Please check the model name, or ask our team — we may be able to help:" + handoff(q, reqCtx(A, q)) + col));
      return;
    }
    var label = vehicleLabel(A, items);
    saveVeh(label);
    // vehicle known but no part asked and lots of results: let the customer pick a category first
    if (!A.parts.length && items.length > 4) {
      var counts = {}; items.forEach(function (p) { counts[p.pt] = (counts[p.pt] || 0) + 1; });
      var types = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).slice(0, 8);
      var tchips = types.map(function (t) { return chip(esc(t) + " (" + counts[t] + ")", label + " " + t); }).join("");
      wire(botHTML("We have <b>" + items.length + " parts</b> for the <b>" + esc(label) + "</b> 🚗 What are you looking for?<div class=\"cai-chips\">" + tchips + "</div>" + moreLink(r)));
      return;
    }
    var partTxt = A.parts.length ? A.parts.map(function (p) { return p.label; }).join(" & ") : "parts";
    var head = r.reason === "nearest"
      ? "I couldn't find an exact match for <b>" + esc(A.year) + "</b>, but here are the closest options — please check the year range on the listing 👇"
      : "Here " + (items.length === 1 ? "is <b>1 match</b>" : "are <b>" + items.length + " matches</b>") + " for <b>" + esc(label) + "</b>" + (A.parts.length ? " · " + esc(partTxt) : "") + " 👇";
    var h = head;
    items.slice(0, 4).forEach(function (p) { h += productCard(p); });
    if (items.length > 4) h += moreLink(r);
    wire(botHTML(h));
  }
  function noResult(q, r) {
    var A = r.A;
    if (r.reason === "needvehicle") {
      var p = A.parts[0];
      botType("Which vehicle is it for? 🚗 Tell me the <b>make, model and year</b> — e.g. “Nissan Navara 2017 " + esc(p.label.replace(/s$/, "")) + "”."
        + (p.col ? "<br>Or browse all <a href=\"" + esc(url("collections/" + p.col)) + "\">" + esc(p.label) + "</a>." : ""));
      return;
    }
    if (r.reason === "needmodel") {
      var mk = A.makes[0], models = Object.keys(MODELS).map(function (k) { return MODELS[k]; }).filter(function (m) { return sameMake(m.make, mk); }).sort(function (a, b) { return b.n - a.n; }).slice(0, 8);
      var label = MAKES[mk] ? MAKES[mk].label : mk;
      if (!models.length) { botType("I couldn't find any <b>" + esc(label) + "</b> parts in our range right now 😕 Our team can check for you:" + handoff(q, reqCtx(A, q)), function () { wire(body.lastChild); }); return; }
      var chips = models.map(function (m) { return chip(esc(m.model), m.makeLabel + " " + m.model + (A.year ? " " + A.year : "")); }).join("");
      wire(botHTML("Which <b>" + esc(label) + "</b> model is it? 👇<div class=\"cai-chips\">" + chips + "</div><a class=\"cai-more\" href=\"" + esc(url("collections/" + (MAKE_COLLECTION[mk] || slug(label)))) + "\">Browse all " + esc(label) + " parts →</a>"));
      return;
    }
    if (r.reason === "nopart") {
      var counts = {}; r.other.forEach(function (p) { counts[p.pt] = (counts[p.pt] || 0) + 1; });
      var types = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).slice(0, 6);
      var vl = vehicleLabel(A);
      var chips2 = types.map(function (t) { return chip(esc(t) + " (" + counts[t] + ")", vl + " " + t); }).join("");
      wire(botHTML("We don't have <b>" + esc(A.parts.map(function (p) { return p.label; }).join(" & ")) + "</b> for the <b>" + esc(vl) + "</b> at the moment 😕 But we do have:<div class=\"cai-chips\">" + chips2 + "</div>Or request it and our team will check:" + handoff(q, reqCtx(A, q))));
      return;
    }
    if (r.reason === "nothing") {
      botType("Tell me your vehicle's <b>make, model and year</b> and the part you need — e.g. “VW Transporter T6 2018 wind deflectors”. 🚐");
      return;
    }
    var vl2 = vehicleLabel(A);
    wire(botHTML("Sorry, I couldn't find a match" + (vl2 ? " for <b>" + esc(vl2) + "</b>" : "") + " in our range right now 😕 Our team can check stock and upcoming parts for you:" + handoff(q, reqCtx(A, q))));
  }

  /* ------------------------ part request form ------------------------ */
  function field(name, ph, val, type, extra) {
    return '<input class="cai-in-f" name="' + name + '" type="' + (type || "text") + '" placeholder="' + esc(ph) + '" value="' + esc(val || "") + '" ' + (extra || "") + ">";
  }
  function showRequestForm(ctx) {
    var row = botHTML("<b>📝 Request this part</b><br>Leave your details and our team will check availability and get back to you."
      + '<form class="cai-form" novalidate>'
      + field("name", "Full name *", "", "text", 'autocomplete="name" maxlength="80"')
      + field("phone", "Phone number *", "", "tel", 'autocomplete="tel" maxlength="30"')
      + field("email", "Email address *", "", "email", 'autocomplete="email" maxlength="120"')
      + '<div class="cai-f2">' + field("make", "Make *", ctx.make, "text", 'maxlength="40"') + field("model", "Model *", ctx.model, "text", 'maxlength="60"') + "</div>"
      + '<div class="cai-f2">' + field("year", "Year *", ctx.year, "text", 'inputmode="numeric" maxlength="9"') + field("part", "Part *", ctx.part, "text", 'maxlength="80"') + "</div>"
      + '<textarea class="cai-in-f" name="note" rows="2" maxlength="500" placeholder="Anything else? (optional)"></textarea>'
      + '<input class="cai-hp" name="website" type="text" tabindex="-1" autocomplete="off" aria-hidden="true">'
      + '<div class="cai-err" role="alert"></div>'
      + '<button type="submit" class="cai-cart">Send request</button>'
      + '<div class="cai-legal">We only use these details to reply to this request.</div>'
      + "</form>");
    var form = row.querySelector("form"), err = row.querySelector(".cai-err"), btn = form.querySelector("button"), shownAt = Date.now();
    setTimeout(function () { try { form.elements.name.focus({ preventScroll: true }); } catch (e) {} try { row.scrollIntoView({ block: "start", behavior: "smooth" }); } catch (e) {} }, 60);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = {}; ["name", "phone", "email", "make", "model", "year", "part", "note", "website"].forEach(function (k) { v[k] = (form.elements[k].value || "").trim(); });
      Array.prototype.forEach.call(form.querySelectorAll(".cai-bad"), function (x) { x.classList.remove("cai-bad"); });
      var bad = [];
      if (v.name.length < 2) bad.push("name");
      if (v.phone.replace(/[^0-9]/g, "").length < 7) bad.push("phone");
      if (!/^[^@ ]+@[^@ ]+[.][^@ .]{2,}$/.test(v.email)) bad.push("email");
      ["make", "model", "year", "part"].forEach(function (k) { if (!v[k]) bad.push(k); });
      if (bad.length) {
        bad.forEach(function (k) { form.elements[k].classList.add("cai-bad"); });
        err.textContent = (bad.indexOf("email") >= 0 && v.email) ? "Please check your email address." : "Please fill in the highlighted fields.";
        form.elements[bad[0]].focus();
        return;
      }
      err.textContent = ""; btn.disabled = true; btn.textContent = "Sending…";
      var payload = { type: "part_request", name: v.name, phone: v.phone, email: v.email, make: v.make, model: v.model, year: v.year, part: v.part, note: v.note,
        website: v.website, product: ctx.product || "", productUrl: ctx.productUrl || "", query: ctx.query || "", page: location.href.split("#")[0], elapsed: Date.now() - shownAt };
      var done = false, to = setTimeout(function () { fail(); }, 15000);
      function fail() {
        if (done) return; done = true; clearTimeout(to);
        btn.disabled = false; btn.textContent = "Send request";
        err.innerHTML = "Sorry, we couldn't send that right now. Please try again or message us:" + handoff("part request: " + [v.make, v.model, v.year, v.part].join(" "));
        wire(err);
        track("cai_part_request_fail", {});
      }
      if (!CFG.worker) return fail();
      fetch(CFG.worker, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (done) return;
          if (!j || !j.ok) return fail();
          done = true; clearTimeout(to);
          row.firstChild.innerHTML = "✅ Thanks, <b>" + esc(v.name.split(" ")[0]) + "</b>! Your request for <b>" + esc([v.make, v.model, v.year].join(" ")) + "</b> · " + esc(v.part)
            + " has been sent. Our team will get back to you by phone or email as soon as possible.";
          scroll();
          track("cai_part_request", { make: v.make, model: v.model, year: v.year, part: v.part });
        })
        .catch(fail);
    });
  }

  function addToCart(vid, title, btn) {
    btn.disabled = true; btn.textContent = "Adding…";
    fetch(url("cart/add.js"), { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
      .then(function () {
        btn.textContent = "✓ Added"; toast("Added to your basket", url("cart"), "View basket");
        track("cai_add_to_cart", { item: title });
        refreshCartBubble();
      })
      .catch(function () { btn.disabled = false; btn.textContent = "Add to basket"; toast("Couldn't add that — please try again"); });
  }
  function refreshCartBubble() {
    fetch(url("?sections=cart-icon-bubble"), { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (j) {
      var el = document.getElementById("cart-icon-bubble"), html = j && j["cart-icon-bubble"];
      if (!el || !html) return;
      var doc = new DOMParser().parseFromString(html, "text/html"), sec = doc.querySelector(".shopify-section");
      el.innerHTML = sec ? sec.innerHTML : doc.body.innerHTML;
    }).catch(function () {});
    try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (e) {}
  }

  /* ---------------------------- AI bridge ---------------------------- */
  function askAI(q, cb) {
    if (!CFG.worker) return cb(null);
    var done = false, to = setTimeout(function () { if (!done) { done = true; cb(null); } }, 9000);
    fetch(CFG.worker, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ message: q, site: "cappafe-uk" }) })
      .then(function (r) { if (!r.ok) throw new Error("ai"); return r.json(); })
      .then(function (j) { if (!done) { done = true; clearTimeout(to); cb(j); } })
      .catch(function () { if (!done) { done = true; clearTimeout(to); cb(null); } });
  }
  function aiFallback(q, r) {
    var dots = typingDots();
    askAI(q, function (res) {
      dots.remove();
      track("cai_ai", { query: q, intent: res ? res.intent : "fail" });
      if (!res) return noResult(q, r);
      if (res.intent === "product") {
        var q2 = [res.brand || res.make, res.model, res.year, res.part].filter(Boolean).join(" ").trim();
        var r2 = q2 ? search(q2) : null;
        if (r2 && r2.items.length) return showResults(q2, r2);
        if (r2 && r2.reason !== "nothing") return noResult(q2, r2);
        return botType((res.reply ? esc(res.reply) + "<br>" : "") + "I couldn't find that in our range right now 😕 Our team can check for you:" + handoff(q, reqCtx(analyse(q2 || q), q)), function () { wire(body.lastChild); });
      }
      botType(res.reply ? esc(res.reply) : "How can I help? 🚗 Tell me your vehicle's make, model and year.");
    });
  }

  /* ------------------------------ router ------------------------------ */
  var ACKS = ["On it — finding parts that fit your vehicle… 🔧", "Great, let me check what fits… 🚗", "One sec, filtering our range for your vehicle… 🔍"], ackI = 0;
  function looksLikeVehicle(q) {
    var A = analyse(q);
    return !!(A.year || A.parts.length || A.makes.length || A.models.length);
  }
  function go() {
    var q = (input.value || "").trim();
    if (!q) return;
    flushTyping();
    input.value = ""; userText(q.slice(0, 300));
    var sm = small(q);
    if (sm) { afterDots(450, function () { botType(sm); track("cai_smalltalk", { query: q }); }); return; }

    function proceed() {
      var dots = typingDots();
      load(function () {
        setTimeout(function () {
          dots.remove();
          var A = analyse(q);
          var fid = A.models.length ? null : faqFind(q);
          if (fid) {
            var ans = faqAnswers()[fid];
            var withHand = (fid === "contact" || fid === "track");
            botType(ans + (withHand ? handoff("") : ""), function () { if (withHand) wire(body.lastChild); });
            track("cai_faq", { query: q, topic: fid });
            return;
          }
          if (!DATA.length) { botHTML("I'm having trouble loading our catalogue right now 😕 Please try again in a moment, or contact our team:" + handoff(q)); wire(body.lastChild); return; }
          var r = search(q);
          track("cai_search", { query: q, results: r.items.length, reason: r.reason });
          if (r.items.length) return showResults(q, r);
          track("cai_no_result", { query: q, reason: r.reason });
          if (CFG.worker && (r.reason === "nothing" || r.reason === "none")) return aiFallback(q, r);
          noResult(q, r);
        }, 380);
      });
    }
    if (looksLikeVehicle(q) && loaded) botType(ACKS[ackI++ % ACKS.length], proceed);
    else proceed();
  }

  /* Welcome teaser: small auto message above the chat button, once per browser session */
  var tipEl = null, tipTimer = null, tipAuto = null;
  function hideTip() {
    clearTimeout(tipTimer); clearTimeout(tipAuto);
    if (tipEl) tipEl.classList.remove("cai-tip-on");
  }
  (function welcomeTip() {
    try { if (sessionStorage.getItem("cai_tip")) return; } catch (e) {}
    if (/^\/(cart|checkout|account)/.test(location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, ""))) return;
    tipEl = document.createElement("div");
    tipEl.className = "cai-tip";
    tipEl.setAttribute("role", "status");
    tipEl.innerHTML = '<button type="button" class="cai-tip-x" aria-label="Dismiss message">&times;</button>' +
      "<b>Hi there 👋</b><span>Looking for a part? Tell me your vehicle and I’ll help you find the right fit.</span>";
    root.appendChild(tipEl);
    tipTimer = setTimeout(function () {
      if (card.classList.contains("cai-open")) return;
      tipEl.classList.add("cai-tip-on");
      try { sessionStorage.setItem("cai_tip", "1"); } catch (e) {}
      track("cai_tip_show", {});
      tipAuto = setTimeout(hideTip, 25000);
    }, 2500);
    tipEl.addEventListener("click", function (e) {
      if (e.target.closest(".cai-tip-x")) { hideTip(); track("cai_tip_close", {}); return; }
      setOpen(true);
      track("cai_tip_click", {});
    });
  })();

  fab.addEventListener("click", function () { setOpen(!card.classList.contains("cai-open")); });
  fab.addEventListener("pointerenter", function () { load(); }, { once: true });
  if (closeBtn) closeBtn.addEventListener("click", function () { setOpen(false); });
  // header "Get in touch" message icon (left of the basket) + any [data-cai-open] / #cappafe-assistant link opens the assistant
  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target.closest(".header__icon--custom, [data-cai-open], a[href$='#cappafe-assistant']") : null;
    if (!t) return;
    e.preventDefault();
    setOpen(true);
    track("cai_open_header", {});
  });
  sendBtn.addEventListener("click", go);
  input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); go(); } });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && card.classList.contains("cai-open")) setOpen(false); });

  // test hook for QA in the browser console (read-only)
  window.__caiDebug = { search: function (q) { return search(q); }, analyse: function (q) { return analyse(q); }, load: load, data: function () { return DATA; } };
})();
